module.exports = __webpack_public_path__ + "img/result_wine_g.6bf408c4.png";